import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import store from '../store';
function checkRole(mustHaveRole, userRole) {
  // Can this be split?
  var _mustHaveRole$split = mustHaveRole.split('_'),
    _mustHaveRole$split2 = _slicedToArray(_mustHaveRole$split, 2),
    key = _mustHaveRole$split2[0],
    value = _mustHaveRole$split2[1];
  return Boolean(userRole[key]) && (userRole[key] === true || userRole[key] === value || userRole[key] === 'write') // write is the maximum setting
;
}
export function hasPrivilege(mustHaveOneOfRoles) {
  var role = store('role');
  if (!role) {
    return;
  }

  // Implicit everything
  if (role.super) {
    return true;
  }
  if (mustHaveOneOfRoles === 'member') {
    // Everyone has this role
    return true;
  }
  if (Array.isArray(mustHaveOneOfRoles)) {
    return mustHaveOneOfRoles.some(function (mustHaveRole) {
      return checkRole(mustHaveRole, role);
    });
  } else {
    return checkRole(mustHaveOneOfRoles, role);
  }
}